import Vue from "vue";
import Vuex from "vuex";
import cognito from "@/stores/cognito";
import init from "@/stores/init";
import organization from "@/stores/organization";
import role from "@/stores/role";
import avatar from "@/stores/avatar";
import location from "@/stores/location";
import terminal from "@/stores/terminal";
import businessActivation from "@/stores/businessActivation";
import memberInvites from "@/stores/memberInvites";

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [init],
  modules: {
    cognito,
    organization,
    role,
    avatar,
    location,
    terminal,
    businessActivation,
    memberInvites,
  },
});
